import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import { getDefaultRoutePrefix } from '../config/runtimeConfig';

interface RouteState {
  routePrefix: string;
  setRoutePrefix: (companyName: string | null) => void;
  getRoutePrefix: () => string;
  resetRoutePrefix: () => void;
}

// Convert company name to URL-safe slug
const toUrlSlug = (companyName: string | null): string => {
  if (!companyName) {
    return getDefaultRoutePrefix();
  }
  
  return '/' + companyName
    .toLowerCase()
    .trim()
    .replace(/[^\w\s-]/g, '') // Remove special characters
    .replace(/\s+/g, '-')      // Replace spaces with hyphens
    .replace(/-+/g, '-')       // Replace multiple hyphens with single hyphen
    .replace(/^-+|-+$/g, '');  // Remove leading/trailing hyphens
};

export const useRouteStore = create<RouteState>()(
  persist(
    (set, get) => ({
      routePrefix: getDefaultRoutePrefix(),
      
      setRoutePrefix: (companyName: string | null) => {
        const newPrefix = toUrlSlug(companyName);
        set({ routePrefix: newPrefix });
      },
      
      getRoutePrefix: () => {
        return get().routePrefix;
      },
      
      resetRoutePrefix: () => {
        const defaultPrefix = getDefaultRoutePrefix();
        set({ routePrefix: defaultPrefix });
      },
    }),
    {
      name: 'route-store',
      storage: createJSONStorage(() => localStorage),
    }
  )
);

// Export the slug converter for use in other places if needed
export { toUrlSlug };

